import { Button } from '@lmc/ui-kit'
import type React from 'react'

interface EmarNextStepButtonProps {
  handleNext: () => void
  testId?: string
  // Add other props as needed
}

const EmarNextStepButton: React.FC<EmarNextStepButtonProps> = (props) => {
  const { handleNext, testId } = props

  return (
    <Button
      onClick={handleNext}
      variant="primary"
      data-testid={testId ? `${testId}-next-step-button` : 'next-step-button'}
    >
      Next Step
    </Button>
  )
}

export default EmarNextStepButton
